export default __webpack_public_path__ + "static/media/Graphik-Light.358ffe0c.woff";